import React, { useState, useEffect, useMemo } from 'react'
import { getSession } from '../../../auth'
import { Box, Fade, Grow } from '@mui/material'
import AvatarName from '../../AvatarName'
import api from '../../../api'
import NPSChart from '../../D3/NPSChart'

export const getNps = async (id, setNps) => {
    const enterpriseId = getSession().profile.enterprise.id

    const res = await api.get(`api/enterprises/${enterpriseId}/contacts/${id}/get_nps/`)
    if (res.status === 200){
        setNps(res.data)
    } 
}

const NpsSimbol = ({value}) => {

    const [color, text] = useMemo(()=>{
        if ([-1, ''].includes(value)) return ['#a3a3a3', 'SEM NPS']
        if (value <= 6)
            return ['#e3413f', 'DETRATOR']
        else if (value <= 8)
            return ['#e89b4f', 'NEUTRO']
        else if (value <= 10)
            return ['#03b86a', 'PROMOTOR']
        else return ['#03b86a', 'PROMOTOR']
    }, [value])
    


    return (
        <>
            <Box className='nps-circle' sx={{background: color}}>
                <Box className='nps-circle-icon-anchor'>
                    <Box className='nps-circle-icon'>
                        <svg width="100%" height="100%" viewBox="0 0 100 100" 
                            xmlns="http://www.w3.org/2000/svg">
                        <polygon
                            points="50,5 61,35 95,35 68,57 79,91 50,72 21,91 32,57 5,35 39,35"
                            fill="#fdeeca"
                            stroke="#fdeeca"
                            stroke-width="8"
                            stroke-linejoin="round"
                            style={{paintOrder: 'stroke fill'}}
                        />
                    </svg>
                        {/* <Box className='nps-star'></Box> */}
                    </Box>
                </Box>
                <Box className='nps-circle-detail'></Box>
                <Box className='nps-circle-value'>{value === -1 ? '' : value}</Box>
                <Box className='nps-circle-text'>{text}</Box>
            </Box>
        </>
    )
}

const ContactAvatarProfile = ({ parent, contactName }) => {

    const [nps, setNps] = useState(null)

    useEffect(()=>{
        getNps(parent.id, setNps)
    }, [])

    return (
        <>
            <Box className="avatar-profile nps">
                <Box className='avatar-profile-wrapper'>
                    {parent.name
                        ? <AvatarName name={parent.name} size="big" />
                        : <AvatarName name="N" size="big" />
                    }
                    {contactName}
                </Box>
                    <span className='span-relative-nps-box' style={{opacity: nps === null ? 0 : 1}}>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}} width={'100%'} >
                            <NpsSimbol value={nps} key={`nps-update-${nps}`} />
                            {/* <NPSChart value={nps} key={`nps-update-${nps}`} needle styleProps={{position:'relative'}} titleProps={{position:'absolute', left: '1.2rem', top:'-0.4rem'}}/> */}
                        </Box>
                    </span>

            </Box>
        </>
    )
}

export default ContactAvatarProfile